module.exports = __webpack_public_path__ + "static/media/logo-mono-white.42950fa1.png";